import { useEffect } from 'react'

export function useSafariOrientationChangeHandler() {
  useEffect(() => {
    function isAppleDevice() {
      return (
        /iPad|iPhone|iPod/.test(navigator.userAgent) ||
        (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
      )
    }

    if (isAppleDevice()) {
      function adjustBodyHeight() {
        // Get the current viewport height
        const viewportHeight = window.innerHeight

        // Set the body's height dynamically
        document.body.style.height = `${viewportHeight}px`
        document.body.style.overflow = 'hidden' // Prevent excessive scrolling
      }

      // Adjust height on load and resize
      window.addEventListener('load', adjustBodyHeight)
      window.addEventListener('resize', adjustBodyHeight)

      // Handle orientation changes
      window.addEventListener('orientationchange', () => {
        setTimeout(() => {
          window.scrollTo(0, 1) // Slight scroll to trigger address bar adjustment
          adjustBodyHeight() // Recalculate the height
        }, 300) // Delay to allow the orientation change to settle
      })

      // Initial adjustment (extra safety)
      setTimeout(() => {
        adjustBodyHeight()
        window.scrollTo(0, 1) // Ensure the address bar is visible at start
      }, 100)
    }
  }, [])
}
